import type {  Section } from "./formTypeStructure";


/**
 * Normalise les données reçues depuis react-hook-form, en restructurant
 * les champs des groupes répétables dans un format par tableau d'objets.
 *
 * @param flatData Données plates de RHF (ex: champ_0, champ_1, etc.)
 * @param sections Sections du formulaire (chacune contient des champs)
 * @returns Données restructurées prêtes à être persistées ou envoyées
 */
export function normalizeFormData(
  flatData: Record<string, any>,
  sections: Section[]
): Record<string, any> {
  const result: Record<string, any> = {};
  const usedKeys = new Set<string>();

  for (const section of sections) {
    for (const field of section.formFields) {
      const group = field.repeatGroup;

      if (group) {
        const fieldNames = group.formFields.map((f) => f.fieldName);
        const groupInstances: Record<string, any>[] = [];
        const maxRepeats = 20;

        for (let i = 0; i < maxRepeats; i++) {
          const instance: Record<string, any> = {};
          let hasValue = false;

          for (const childFieldName of fieldNames) {
            const fullKey = `${group.fieldName}_${childFieldName}_${i}`;
            // if (flatData.hasOwnProperty(fullKey)) {
            if (Object.prototype.hasOwnProperty.call(flatData, fullKey)) {
              instance[childFieldName] = flatData[fullKey];
              usedKeys.add(fullKey);
              if (flatData[fullKey] !== "" && flatData[fullKey] != null) {
                hasValue = true;
              }
            }
          }

          if (hasValue) {
            groupInstances.push(instance);
          }
        }

        result[group.fieldName] = groupInstances;
      }
    }
  }

  // Ajouter les champs simples (hors repeatGroups)
  for (const [key, value] of Object.entries(flatData)) {
    if (!usedKeys.has(key)) {
      result[key] = value;
    }
  }

  return result;
}

/**
 * Dénormalise les données normalisées vers leur format plat original.
 * Cette fonction est l'inverse de normalizeFormData.
 *
 * @param normalizedData Données normalisées (avec groupes répétables)
 * @param sections Sections du formulaire (chacune contient des champs)
 * @returns Données plates prêtes à être utilisées par le formulaire
 */
export function denormalizeFormData(
  normalizedData: Record<string, any>,
  sections: Section[]
): Record<string, any> {
  const result: Record<string, any> = { ...normalizedData };
  console.log('🔄 denormalizeFormData - données d\'entrée:', normalizedData);

  for (const section of sections) {
    for (const field of section.formFields) {
      const group = field.repeatGroup;

      if (group && normalizedData[group.fieldName]) {
        const groupInstances = normalizedData[group.fieldName];
        console.log(`🔄 Traitement du groupe ${group.fieldName}:`, groupInstances);
        
        if (Array.isArray(groupInstances)) {
          // Supprimer la clé normalisée
          delete result[group.fieldName];
          
          // Restaurer les données plates
          groupInstances.forEach((instance: Record<string, any>, index: number) => {
            if (instance && typeof instance === 'object') {
              Object.entries(instance).forEach(([childFieldName, value]) => {
                const fullKey = `${group.fieldName}_${childFieldName}_${index}`;
                result[fullKey] = value;
                console.log(`🔄 Restauration: ${fullKey} = ${value}`);
              });
            }
          });
        }
      }
    }
  }

  console.log('🔄 denormalizeFormData - données de sortie:', result);
  return result;
}